(function () {
  'use strict';

  function recipientsFactory (apiFactory, Common, postalCodesFactory, $http) {
    const overAllAddressLimit = 50000; // Hard limit set from address validator
    let addingAddresses = 'not_start';

    let validAddressCount = 0;
    let invalidAddressCount = 0;

    let addressFile = Common.get('originalAddressFileName', null);

    const bisnodeRequests = {
      gross: null,
      refined: null
    };

    function setAddressFile (file) {
      addressFile = file;
    }

    function getAddressFile () {
      return addressFile;
    }

    function setAddingAddresses (status) {
      addingAddresses = status;
    }

    function checkAddingAddresses () {
      return addingAddresses;
    }

    function setValidAddressCount (addressCount) {
      validAddressCount = addressCount;
    }

    function getValidAddressCount () {
      return validAddressCount;
    }
    function setInvalidAddressCount (addressCount) {
      invalidAddressCount = addressCount;
    }

    function getInvalidAddressCount () {
      return invalidAddressCount;
    }

    function toJson (wb) {
      const result = {};
      wb.SheetNames.forEach(function (sheetName) {
        const roa = XLSX.utils.sheet_to_row_object_array(wb.Sheets[sheetName]);
        if (roa.length > 0) {
          result[sheetName] = roa;
        }
      });

      return result;
    }

    function decodeArrBuffer (uArr) {
      let binary = '';
      const len = uArr.byteLength;

      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(uArr[i]);
      }

      return binary;
    }

    function checkAddressLimit (file, invalidFile, cb) {
      // var buff;
      const reader = new FileReader();

      reader.onload = function (e) {
        const data = e.target.result;
        const uArr = new Uint8Array(data);
        const arr = decodeArrBuffer(uArr);
        const wb = XLSX.read(btoa(arr), { type: 'base64' });
        cb(toJson(wb), file, invalidFile);
      };

      reader.readAsArrayBuffer(file);

    }

    function checkAddress (address) {
      // checks if the input is just a white space or null
      if (!address.addressLineTwo || address.addressLineTwo.replace(/^\s+/, '').replace(/\s+$/, '') === '') {
        delete address.addressLineTwo;
      }

      return address;
    }

    function getSampleColumns (service) {
      const data = {
        service: service,
        market: pnTopbar.market
      };

      return apiFactory.getSampleColumns.get(data).$promise;
    }

    function fetchCustomers () {
      return apiFactory.fetchCustomers.get().$promise;
    }

    function mapCustomerObj (item) {
      return Object.keys(item).map(function (key) {
        return item[key];
      })[0];
    }

    function modifyCustomerResponse (res) {
      return res.map(mapCustomerObj);
    }

    function changeLimitToDisplay (val) {
      let newVal = angular.copy(val);
      newVal = newVal / 1000;
      const splitVal = newVal.toString().split('.');
      newVal = splitVal[0] === '0' ? val : splitVal[0];

      if (splitVal[1] && splitVal[0] !== '0') {
        const secondVal = {
          1: '00',
          2: '0'
        };

        newVal = newVal + '.' + (splitVal[1].length < 3 ? secondVal[splitVal[1].length] : splitVal[1]);
      } else {
        if (parseInt(val) !== parseInt(newVal)) {
          newVal = newVal + '.000';
        }
      }


      return newVal;
    }

    function transformZipcodes (zipcodes) {
      const codes = zipcodes
        .split(',')
        .map((code) => { return Number(code); })
        .sort();
      codes.push(-1);

      const merged = [];

      const merge = (code, count) => {
        const value = `${code - count + 1}-${code}`;
        merged.push(value);
      };

      let prev;
      let first = prev = codes[0];
      let count = 1;

      for (let i = 1; i < codes.length; i++) {
        const curr = codes[i];
        if (prev + 1 === curr) {
          count += 1;
        } else {
          if (count >= 3) {
            merge(prev, count);
          } else if (count === 2) {
            merged.push(first);
            merged.push(prev);
          } else {
            merged.push(prev);
          }

          first = curr;
          count = 1;
        }
        prev = curr;
      }

      return merged.join(',');
    }

    function getPotentialReach (data) {

      // cancel existing gross request
      if (!data.id && bisnodeRequests.gross && !bisnodeRequests.gross.$resolved) {
        bisnodeRequests.gross.$cancelRequest();
      }

      // cancel existing refined request
      if (data.id && bisnodeRequests.refined && !bisnodeRequests.refined.$resolved) {
        bisnodeRequests.refined.$cancelRequest();
      }

      data.zipcodes = transformZipcodes(data.zipcodes);
      const request = apiFactory.getPotentialReach.post(data);

      if (data.id) {
        bisnodeRequests.refined = request;
      } else {
        bisnodeRequests.gross = request;
      }

      return request.$promise;
    }

    function fetchCompanyAddressCount (request) {
      request.zipcodes = transformZipcodes(request.zipcodes); // transforms 10000,10001,10002 into 10001-10002, greatly cutting the amount of bytes used
      return $http.post(web2print.env.recipientsBaseUrl + 'bbc/count', request).then((data)=>{ return data.data; });
    }

    function getIndividualsCountOdr (request) {
      return apiFactory.getIndividualsCountOdr.post(request).$promise;
    }

    function getCompanyCountOdr (request) {
      return apiFactory.getCompanyCountOdr.post(request).$promise;
    }

    // format integer for display in UI
    function formatNumberForSummary (number) {
      if (number > 30000) {
        number = 30000;
      }

      return Common.formatNumber(number || 0);
    }

    function addressLimit () {
      const serviceType = Common.get('serviceType');
      const limits = {
        'information': {
          min: 1,
          max: 9999
        },
        'DKLetters': {
          min: 1,
          max: 30000
        },
        'paymentSlips': {
          min: 1,
          max: 9999
        },
        'admail-letter': {
          min: 100,
          max: 30000
        },
        'admail-postcard': {
          min: 100,
          max: 30000
        },
        'admail-flyers': {
          min: 100,
          max: 30000
        },
        'admail-odr': {
          min: 0,
          max: 1000000000 //easy fix
        }
      };

      if (angular.isUndefined(serviceType)) {
        console.warn('$localStorage.serviceType is undefined. Can not get address limits.');
        return {
          min: 1,
          max: 100000
        };
      }

      return limits[serviceType];
    }

    return {
      checkAddressLimit,
      checkAddress,
      getSampleColumns,
      fetchCustomers,
      modifyCustomerResponse,
      changeLimitToDisplay,
      addressLimit,
      setAddingAddresses,
      checkAddingAddresses,
      getValidAddressCount,
      setValidAddressCount,
      getInvalidAddressCount,
      setInvalidAddressCount,
      getAddressFile,
      setAddressFile,
      getPotentialReach,
      formatNumberForSummary,
      fetchCompanyAddressCount,
      getIndividualsCountOdr,
      getCompanyCountOdr,
      transformZipcodes,
      switchAddressType: postalCodesFactory.switchAddressType,
      overAllAddressLimit
    };
  }

  angular.module('web2print.recipients')
    .factory('recipientsFactory', recipientsFactory);
})();
